<p-toolbar styleClass="pl-0">
	<ng-template pTemplate="left">
		<!-- Bouton exporter -->
		<div>
			<button
				type="button"
				pButton
				icon="pi pi-download"
				[label]="'common.export_action_label' | translate"
				(click)="exporterHistorique()"
				[loading]="exportLoading"
			></button>
		</div>
	</ng-template>
</p-toolbar>


<p-table
	#tableHistorique
	[value]="values"
	[lazy]="true"
	(onLazyLoad)="loadHistorique($event)"
	[loading]="loading"
	[paginator]="true"
	[rows]="rows"
	[showCurrentPageReport]="true"
	[totalRecords]="totalRecords"
	currentPageReportTemplate="{{totalRecords | number}} {{'common.table_total_records'|translate}}"
	paginatorDropdownAppendTo="body"
	[rowsPerPageOptions]="[10,25,50]"
	styleClass="p-datatable-sm p-datatable-gridlines table-scrollable-hover"
	[autoLayout]="true"
	responsiveLayout="scroll"
	scrollDirection="both"
	[scrollable]="true"
	scrollHeight="flex"
>
	<!-- Header -->
	<ng-template pTemplate="header">
		<tr>
			<th class="text-center">
				{{ 'common.modification_date_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'textes.active_state' | translate }}
			</th>

			<th class="text-center">
				{{ 'textes.draft' | translate }}
			</th>

			<th class="text-center">
				{{ 'textes.major_modification_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'textes.abrogated' | translate }}
			</th>

			<th class="text-center">
				{{ 'textes.exclusivement_modificatif_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.modifier_label' | translate }}
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-hist>
		<tr>
			<td>{{hist.txt_date | date:'short'}}</td>

			<td class="text-center"> {{ hist.txt_actif | yesno }} </td>

			<td class="text-center"> {{ hist.txt_brouillon | yesno }} </td>

			<td class="text-center"> {{ hist.txt_modification_majeure | yesno }} </td>

			<td class="text-center"> {{ hist.txt_abrogation | yesno }} </td>

			<td class="text-center"> {{ hist.txt_exclusivement_modificatif | yesno }} </td>

			<td>{{hist | utilisateur:true}}</td>
		</tr>
	</ng-template>

</p-table>
